/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import type { PayloadAction } from "@reduxjs/toolkit";

const name = "swiftwireTemplates";

type SwiftwireTemplatesState = {
  byId: { [key: API.SwiftWireTemplateId]: API.SwiftWireTemplate };
};

const initialState: SwiftwireTemplatesState = {
  byId: {},
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    upsertAll: (state, action: PayloadAction<Array<API.SwiftWireTemplate>>) => {
      const byId: SwiftwireTemplatesState["byId"] = {};
      action.payload.forEach((template) => {
        byId[template.id] = template;
      });
      state.byId = byId;
    },
    updateOne: (state, action: PayloadAction<API.SwiftWireTemplate>) => {
      const template = action.payload;
      state.byId[template.id] = template;
    },
    deleteOne: (state, action: PayloadAction<API.SwiftWireTemplateId>) => {
      const templateId = action.payload;
      delete state.byId[templateId];
    },
  },
});

export const { actions } = slice;

export default {
  [name]: slice.reducer,
};
